module.exports = __webpack_public_path__ + "static/media/fa-regular-400.865738e0.svg";